module.exports = __webpack_public_path__ + "img/Screenshot_from_2020-10-13_14-30-38.e156a0ad.png";